import { ReportSubmitPage } from '@/pages/employee/report/ReportSubmitPage';

export function LeaderReportMobilePage() {
  return <ReportSubmitPage variant="mobile" />;
}
